import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntentIncludedPipe } from './intent-included.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [IntentIncludedPipe],
  exports: [IntentIncludedPipe]
})
export class IntentIncludedPipeModule {} 
